// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteCategoriesStyles } from "@steiner/Overrides/Widgets/Header/AutocompleteCategories";
import { css } from "styled-components";

autocompleteCategoriesStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

autocompleteCategoriesStyles.categoriesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

autocompleteCategoriesStyles.categoryItemText = {
    size: "12px",
    lineHeight: "15px",
};

autocompleteCategoriesStyles.link = {
    typographyProps: {
        size: "12px",
        lineHeight: "15px",
    },
};

autocompleteCategoriesStyles.headerText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};
